export const solutions = {
  hero: {
    title: 'Soluções',
    subtitle: 'Arquitetura financeira aplicada a decisões patrimoniais estruturadas.'
  },
  items: [
    {
      id: 'aquisicao-imobiliaria',
      title: 'Aquisição Imobiliária',
      forWho: {
        label: 'Para quem é',
        text: 'Pessoas físicas e jurídicas que buscam adquirir imóveis residenciais ou comerciais com estrutura de crédito planejada e governança técnica.'
      },
      whenMakesSense: {
        label: 'Quando faz sentido',
        text: 'Quando há clareza sobre o ativo desejado, capacidade de parcela mensal definida e horizonte de médio a longo prazo para contemplação ou lance.'
      },
      variables: {
        label: 'Variáveis e restrições',
        text: 'Valor do bem, prazo do grupo, taxa de administração, fundo de reserva, dinâmica de contemplação (sorteio/lance), regulamento da administradora.'
      },
      howFgt: {
        label: 'Como a FGT estrutura',
        text: 'Diagnóstico patrimonial completo, análise de grupos ativos, modelagem de cenários (base e stress), estruturação de lance quando aplicável, acompanhamento até a utilização do crédito.'
      }
    },
    {
      id: 'construcao-reforma',
      title: 'Construção e Reforma',
      forWho: {
        label: 'Para quem é',
        text: 'Proprietários de terrenos ou imóveis que planejam construir ou reformar com crédito estruturado via consórcio imobiliário.'
      },
      whenMakesSense: {
        label: 'Quando faz sentido',
        text: 'Quando há projeto definido, orçamento técnico validado e necessidade de crédito sem comprometimento imediato de liquidez patrimonial.'
      },
      variables: {
        label: 'Variáveis e restrições',
        text: 'Valor da obra, documentação do imóvel, aprovação de projeto pela administradora, liberação de crédito em etapas, prazo de execução.'
      },
      howFgt: {
        label: 'Como a FGT estrutura',
        text: 'Validação técnica do projeto, análise de viabilidade documental, modelagem de crédito por etapas, estruturação de contemplação, gestão de liberações.'
      }
    },
    {
      id: 'planejamento-patrimonial',
      title: 'Planejamento Patrimonial',
      forWho: {
        label: 'Para quem é',
        text: 'Famílias e indivíduos com patrimônio consolidado que buscam diversificação estruturada e proteção de ativos via consórcios de longo prazo.'
      },
      whenMakesSense: {
        label: 'Quando faz sentido',
        text: 'Quando há excedente de caixa recorrente, horizonte de planejamento acima de 5 anos e necessidade de estruturação patrimonial disciplinada.'
      },
      variables: {
        label: 'Variáveis e restrições',
        text: 'Perfil de risco, horizonte temporal, capacidade de parcela, objetivos patrimoniais (sucessão, proteção, diversificação), regulamento dos grupos.'
      },
      howFgt: {
        label: 'Como a FGT estrutura',
        text: 'Diagnóstico patrimonial profundo, mapeamento de objetivos, modelagem de portfólio de grupos, análise de risco e retorno, acompanhamento estratégico contínuo.'
      }
    },
    {
      id: 'estruturacao-empresarial',
      title: 'Estruturação Empresarial',
      forWho: {
        label: 'Para quem é',
        text: 'Empresas que necessitam adquirir ativos operacionais (sede, veículos, equipamentos) com estrutura de crédito sem comprometer capital de giro.'
      },
      whenMakesSense: {
        label: 'Quando faz sentido',
        text: 'Quando há necessidade de expansão ou aquisição de ativos com fluxo de caixa previsível e preferência por crédito estruturado de longo prazo.'
      },
      variables: {
        label: 'Variáveis e restrições',
        text: 'Tipo de ativo, valor do bem, capacidade de pagamento mensal da empresa, documentação societária, regulamento PJ da administradora.'
      },
      howFgt: {
        label: 'Como a FGT estrutura',
        text: 'Análise de viabilidade corporativa, estruturação de crédito PJ, modelagem de fluxo de caixa, gestão documental, acompanhamento até a entrega do ativo.'
      }
    },
    {
      id: 'cartas-contempladas',
      title: 'Cartas Contempladas',
      forWho: {
        label: 'Para quem é',
        text: 'Compradores que buscam crédito imediato via aquisição de cartas já contempladas, com curadoria técnica e validação de risco operacional.'
      },
      whenMakesSense: {
        label: 'Quando faz sentido',
        text: 'Quando há urgência na aquisição do ativo, disponibilidade de capital para entrada (ágio + parcelas pagas) e necessidade de crédito imediato.'
      },
      variables: {
        label: 'Variáveis e restrições',
        text: 'Valor da carta, ágio de mercado, parcelas pagas, saldo devedor, taxa de administração, fundo de reserva, prazo restante, regulamento da administradora.'
      },
      howFgt: {
        label: 'Como a FGT estrutura',
        text: 'Curadoria técnica de cartas disponíveis, validação documental completa, análise de risco operacional, negociação de ágio, acompanhamento de transferência e utilização.'
      }
    }
  ],
  cta: {
    title: 'Estruture sua decisão patrimonial',
    subtitle: 'Agendar um diagnóstico estratégico sem compromisso.',
    button: 'Agendar Diagnóstico Estratégico'
  }
};